import { Controller } from 'stimulus'

const DESKTOP_MQ = '(min-width: 768px)'

/**
 * Mobile show/hide for Filterrific. Restores expand state after Turbo
 * toolbar updates so Search does not collapse the panel.
 *
 * Optional value: storageKey (default: filterrific-expanded) — set per page
 * when multiple Filterrific forms should keep independent expand state.
 */
export default class extends Controller {
  static targets = ['collapse', 'toggle']
  static values = { storageKey: { type: String, default: 'filterrific-expanded' } }

  connect() {
    this.boundOnShown = () => this.setExpanded(true)
    this.boundOnHidden = () => this.setExpanded(false)
    this.collapseTarget.addEventListener('shown.bs.collapse', this.boundOnShown)
    this.collapseTarget.addEventListener('hidden.bs.collapse', this.boundOnHidden)

    if (this.shouldStartExpanded()) {
      this.collapseTarget.classList.add('show')
      this.syncToggle(true)
    }
  }

  disconnect() {
    this.collapseTarget.removeEventListener('shown.bs.collapse', this.boundOnShown)
    this.collapseTarget.removeEventListener('hidden.bs.collapse', this.boundOnHidden)
  }

  shouldStartExpanded() {
    if (window.matchMedia(DESKTOP_MQ).matches) return false
    try {
      return sessionStorage.getItem(this.storageKeyValue) === 'true'
    } catch (_) {
      return false
    }
  }

  setExpanded(expanded) {
    try {
      sessionStorage.setItem(this.storageKeyValue, String(expanded))
    } catch (_) { /* private mode */ }
    this.syncToggle(expanded)
  }

  syncToggle(expanded) {
    if (!this.hasToggleTarget) return
    this.toggleTarget.classList.toggle('collapsed', !expanded)
    this.toggleTarget.setAttribute('aria-expanded', String(expanded))
  }
}
